export type SocialSharePlatform = "facebook" | "whatsapp" | "linkedin" | "x";

export function getShareUrl(
  baseUrl: string,
  widgetName: string,
  widgetId: string,
  environment = process.env.NODE_ENV
): string {
  if (environment === "development") {
    return `http://localhost:3344/widget/${widgetName}/${widgetId}`;
  }
  return `${baseUrl}/widget/${widgetName}/${widgetId}`;
}

export function getSocialShareUrl(platform: SocialSharePlatform, url: string): string {
  switch (platform) {
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    case "whatsapp":
      return `https://api.whatsapp.com/send?text=${url}`;
    case "linkedin":
      return `https://www.linkedin.com/shareArticle?mini=true&url=${url}`;
    case "x":
      return `https://twitter.com/intent/tweet?url=${url}`;
  }
}
